import React from 'react';
import EmployeeDocumentsList from './List/EmployeeDocumentsList';
import EmployeeDocumentContextTemplate from './EmployeeDocumentContextTemplate';

const EmployeeDocumentsPage = () => {
  return (
    <EmployeeDocumentContextTemplate>
      <EmployeeDocumentsList />
    </EmployeeDocumentContextTemplate>
  );
};

export default EmployeeDocumentsPage;
